module.exports = __webpack_public_path__ + "static/00020.85c92e2e.jpg";